import { validateUpdateContentTemplate } from './validateUpdateContentTemplate';

export const validateCreateContentTemplate = validateUpdateContentTemplate;
